import type { FormField } from '@/ts/types/schema.types'
import { FieldRuleService } from '@/services/field-rule.service.ts'

export async function validateField(field: FormField): Promise<string | boolean> {
  const fieldRules = FieldRuleService.getRules(field.config.field_rules)
  for (const fieldRule of fieldRules) {
    const result = await fieldRule(field.config.value)
    if ((typeof result === 'string' && result.length) || (typeof result === 'boolean' && !result)) return result
  }
  return true
}
